import script from "./QModalSurprint.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalSurprint.vue?vue&type=script&setup=true&lang=js"

import "./QModalSurprint.vue?vue&type=style&index=0&id=2749396e&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2749396e"]])

export default __exports__